import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Button, Row, Col } from 'antd';
import DatePicker from 'antd/lib/date-picker';

class FormFilterDatePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formFilterDatePicker: {
        input: '',
      },
    };
  }

  onChange = (date, dateString) => {
    const formFilterDatePicker = {
      input: dateString,
    };
    this.setState({ formFilterDatePicker });
  };

  onCancel = () => {
    this.props.cancelFunction(
      this.props.type,
      this.props.flagType,
      this.props.callbackCancel,
    );
  };

  _onValidate = err => {
    if (!err) {
      this.props.onSubmit(
        this.props.type,
        this.state.formFilterDatePicker,
        this.props.flagType,
      );
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    const {
      form: { validateFields },
    } = this.props;

    validateFields(this._onValidate);
  };

  _renderForm = () => {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.handleSubmit}>
        <Row>
          <Col>
            <Form.Item required={false} colon={false}>
              {getFieldDecorator('datePicker', {
                rules: [
                  {
                    required: true,
                    message: 'date required',
                  },
                ],
              })(
                <DatePicker
                  onChange={this.onChange}
                  className="date-picker-style"
                />,
              )}
            </Form.Item>
          </Col>
          <div className="row-submit">
            <Button className="btn cancel-btn" onClick={this.onCancel}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit" className="btn">
              Submit
            </Button>
          </div>
        </Row>
      </Form>
    );
  };

  render() {
    return <div>{this._renderForm()}</div>;
  }
}

FormFilterDatePicker.propTypes = {
  form: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  cancelFunction: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  flagType: PropTypes.string.isRequired,
  callbackCancel: PropTypes.func,
};

export default FormFilterDatePicker;
